import React, { useEffect, useState } from "react";
import $ from 'jquery';
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";

export default function () {
  const navigate = useNavigate();
  const token = useSelector(state => state.token);

  useEffect(() => {
    const baseUrl = process.env.REACT_APP_API_URL;

    let table = $('#pages').DataTable({
      "destroy": true,
      "ajax": {
        url: `${baseUrl}pages`,
        beforeSend: function (request) {
          request.setRequestHeader("Authorization", 'Bearer ' + token);
        },
        error: function (xhr) {
          if (xhr?.status === 401) {
            axios.post('/logout')
              .then(res => {
                localStorage.removeItem('persist:root');
                navigate('/login');
              });
          }
        }
      },
      "columns": [
        { data: 'id', name: 'id' },
        { data: 'name', name: 'name', searchable: true },
        { data: 'keywords', name: 'keywords', searchable: true },
        {
          data: 'edit',
          orderable: false,
          searchable: false,
          render: function (data, type, row) {
            return `<button 
                class="btn btn-primary me-2 mb-2 bg-black-transperent edit"
                row-id="${row.id}">
                  Edit
                </button>`;
          },
        }
      ],
      "order": [[0, "desc"]],
    });

    table.off('click');

    table.on('click', 'button.actions', function () {
      $(this).next(".row-actions").fadeToggle(200).toggleClass("hidden-actions")
    });

    table.on('click', 'button.edit', function () {
      const id = $(this).attr("row-id");
      navigate(`/seo/dynamic-pages/${id}/edit`);
    });

    let datatableSearch = ".dataTables_wrapper .dataTables_filter input[type=search]";
    $("<i class='fas fa-search'></i>")
      .insertBefore(datatableSearch);
    $(datatableSearch)
      .attr("placeholder", "Search...");
  }, []);

  return (<>
    <div className="card mt-4">
      <div className="card-body">
        <div className="card-header d-flex justify-content-center">
          <h3 className="text-center">Dynamic Pages</h3>
        </div>
        <table id="pages" className="table align-middle table-row-dashed fs-6 gy-5">
          <thead>
          <tr className="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
            <th>ID</th>
            <th>Name</th>
            <th>Keywords</th>
            <th>Actions</th>
          </tr>
          </thead>
          <tbody className="text-gray-600 fw-bold">
          </tbody>
        </table>
      </div>
    </div>
  </>);
}